<template>
  <p class="text-body3 text-grey-6 q-mt-xs">
    <slot />
  </p>
</template>

<script>
export default {
  name: 'SAIHint'
};
</script>
